<template lang="html">

  <footer class="footer row-between">

    <div :class="['row-between',($route.name != 'login' ? 'container' : '')]">
    
    <nav class="row-center">
      <a href="https://www.ufv.es/aviso-legal/" target="_blank">Aviso Legal</a>
      <a href="https://www.ufv.es/politica-de-privacidad/" target="_blank">Política de privacidad</a>
      <router-link :to="$t('enlaces.politica_cookies')" target="_blank">Política de cookies</router-link>
      <!-- <a href="https://practicasempleo-ufv.es/" target="_blank">Portal Carreras Profesionales</a> -->
      <a href="https://www.ufv.es/" target="_blank">UFV</a>
    </nav>
    
    <p>2024 © Departamento de Carreras Profesionales Universidad Francisco de Vitoria</p>

  </div>

    <p class="version">v.{{version}}</p>

    <button class="up" @click="up" :show="show">
      <img src="/static/img/down-arrow.svg" alt="Subir">
    </button>

    <button class="cky-banner-element">Configuración Cookies</button>

  </footer>

</template>

<script lang="js">

  import {mapGetters} from 'vuex'

  export default  {
    name: 'app-footer',
    mounted(){
      this.checkshowUp()
      $(window).scroll(e => {
        this.checkshowUp();
      });
    },
    data(){
      return{
        show : false
      }
    },
    computed:{
      ...mapGetters({
        version : 'getVersion'
      })
    },
    methods : {
      up(){
        $('html, body').animate({scrollTop:0}, '500');
      },
      checkshowUp() {
        let top = $(window).scrollTop();
        let limit = 400;
        let difference = $(".header .top").height();

        this.show = (top > (limit - difference));
      }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/parts/footer.vue